<template>
  <div class="member_detail" v-loading="loading">
    <back />
    <div class="s_wrapper">
      <el-cascader class="" v-model="type" :options="options1" placeholder="项目分类" :props="propsOptions" @change="onSearch" collapse-tags clearable></el-cascader>
      <el-input class="s_input" v-model="name" placeholder="请输入项目名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
      <el-select class="s_input" v-model="status" placeholder="请选择项目状态" @change="onSearch" clearable>
        <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" prop="projectName" label="项目名称"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" prop="createdTime" label="付款时间"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" prop="categoryName" label="分类"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" prop="price" label="定价(元)"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="durationMinute" label="服务时长(分钟)"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" prop="projectCount" label="总次数"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" prop="count" label="剩余次数"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="80" label="项目状态">
          <template slot-scope="scope">
            <span :class="scope.row.projectStatus == 2 ? 'project_status' : ''">{{ mapCouponType(scope.row.projectStatus) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      name: "",
      type: "",
      status: "",
      options1: [],
      options2: [
        { value: "1", label: "未完成" },
        { value: "2", label: "已完成" },
      ],
      propsOptions: {
        expandTrigger: "hover",
        label: "categoryName",
        value: "categoryId",
        children: "children",
        emitPath: false,
        checkStrictly: false,
        multiple: true,
      },
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getCategoryInfoList()
    this.getPurchasedList()
  },
  methods: {
    mapCouponType(val) {
      return this.options2.find(e => e.value == val)?.label || ""
    },
    // 分类
    getCategoryInfoList() {
      this.$axios
        .get(this.$api.projectList, {
          params: {
            page: 1,
            pageSize: 9999,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.options1 = res.result.list
            this.options1.map(item => {
              if (item.children.length == 0) {
                item.children = null
              }
            })
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    getPurchasedList() {
      this.loading = true
      this.$axios
        .post(this.$api.memberInfomemberPurchasedPageList, {
          userId: this.$route.query.id,
          projectName: this.name,
          categoryIdList: this.type.length > 0 ? this.type : null,
          projectStatus: this.status,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getPurchasedList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getPurchasedList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getPurchasedList()
    },
  },
}
</script>

<style scoped lang="scss">
.member_detail {
  .project_status {
    color: $themes;
  }
}
</style>
